import { PencilSimpleLine } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IElement } from 'bom/types';
import { Button, IButtonProps } from 'core/components';
import { IJob, IJobPart } from 'jobs/types';
import { Color } from 'theme/enums';

import { UpsertLine } from './UpsertLine';

interface IProps extends IButtonProps {
  job: IJob;
  jobPart: IJobPart;
  element?: IElement;
  buttonElement?: ReactElement;
}

export const EditLineButton = ({ job, jobPart, element, buttonElement, ...rest }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const handleOnClose = () => setIsOpen(false);

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={t('buttonLabelEditJobPartLine')}
        color={Color.PRIMARY}
        startDecorator={<PencilSimpleLine />}
        onClick={() => setIsOpen(true)}
        {...rest}
      />
    );
  }, [buttonElement, rest, t]);

  return (
    <>
      {button}

      <UpsertLine
        isOpen={isOpen}
        onClose={handleOnClose}
        jobId={job.id}
        jobPart={jobPart}
        element={element}
      />
    </>
  );
};
